import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../../../services/api.service';
import { AppState } from "../../../../app.reducer";
import { Store } from "@ngrx/store";
import { UserDataService } from "../../../../services/user-data.service";

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {

  public userData: any = {};
  public loading: boolean = false;

  constructor(private router: Router,
              private apiService: ApiService,
              private store: Store<AppState>,
              private userDataService: UserDataService) { }

  ngOnInit(): void {
    if (sessionStorage.getItem('insuadvisor_token') === null || sessionStorage.getItem('insuadvisor_token') === 'undefined') {
      this.router.navigate(['login']).then();
    } else {
      this.userData = this.userDataService.loadData();
    }
  }

  openDocument(base64:any) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: this.getFileType(base64)});
    const url= window.URL.createObjectURL(blob);
    window.open(url);
  }

  getFileType(base64: any): string {
    const token = base64.charAt(0);
    switch (token) {
      case 'J':
        return 'application/pdf';
      case '/':
        return 'image/jpeg';
      case 'i':
        return 'image/png';
      default:
        return '';
    }
  }

  sendData() {
    this.loading = true;
    setTimeout(() => {
      const data = this.userData;
      delete data.checkPrivacy;
      delete data.checkCalling;
      delete data.license;
      delete data.driverIdentification;
      delete data.specSheet;
      this.apiService.storeFormData(data).subscribe(
          response => {
            this.loading = false;
            if (response.ok && response.ok === true) {
              this.router.navigate(['thanks']).then();
            } else {
              if (response.includes('Unknown Error')) {
                this.router.navigate(['server-error']).then();
              } else if (response.includes('Expired')) {
                this.router.navigate(['auth-error']).then();
              } else {
                this.router.navigate(['server-error']).then();
              }
            }
          }
      )
    }, 3000);
  }

}
